import {
  ReceiptAction,
  ReceiptState,
  SET_RECEIPTS,
  SET_RECEIPTS_LOADED,
  SET_RECEIPT_FILTER,
  SET_TOTAL_RECEIPTS,
} from '../types'

const initialState: ReceiptState = {
  receipts: [],
  totalReceipts: 0,
  isReceiptsLoaded: false,
  receiptFilter: {
    createdDateFrom: new Date(new Date().setDate(1)).getTime(),
    createdDateTo: new Date().getTime(),
    creatorName: '',
    customerName: '',
    reason: '',
    pageSize: 15,
    pageIndex: 1,
  },
}

export const receiptReducer = (
  state = initialState,
  action: ReceiptAction
): ReceiptState => {
  switch (action.type) {
    case SET_RECEIPTS:
      return {
        ...state,
        receipts: action.payload,
      }
    case SET_RECEIPTS_LOADED:
      return {
        ...state,
        isReceiptsLoaded: action.payload,
      }
    case SET_RECEIPT_FILTER:
      return {
        ...state,
        receiptFilter: action.payload,
      }
    case SET_TOTAL_RECEIPTS:
      return {
        ...state,
        totalReceipts: action.payload,
      }
    default:
      return state
  }
}
